module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-11-05 at 21.51.05 (1).8bb48a45.jpeg";